/**
 * Allys News/Blog Listing Skeleton
 *
 * Matches BlogListingContentAllys: post hero with search,
 * filter strip, and 3-column post grid.
 * Includes navigation skeleton so the nav bar is always visible.
 */

import { AllysNavSkeleton } from './AllysNavSkeleton';

export function AllysNewsSkeleton() {
  return (
    <div className="min-h-screen bg-white">
      <AllysNavSkeleton />

      {/* Post hero */}
      <section className="relative py-28 lg:py-36 overflow-hidden bg-gray-200 skeleton-stagger-1">
        <div className="absolute inset-0 bg-linear-to-b from-[#243462]/40 to-[#243462]/20 skeleton-shimmer" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="h-4 w-20 rounded-full bg-white/20 mx-auto mb-4 skeleton-shimmer" />
          <div className="h-12 w-72 max-w-full rounded-lg bg-white/20 mx-auto mb-4 skeleton-shimmer" />
          <div className="h-5 w-96 max-w-full rounded bg-white/10 mx-auto mb-8 skeleton-shimmer" />
          <div className="max-w-md mx-auto h-12 rounded-xl bg-white/15 skeleton-shimmer" />
        </div>
      </section>

      {/* Filter strip */}
      <section className="py-10 bg-white border-b border-gray-100 skeleton-stagger-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-9 w-20 rounded-full bg-gray-100 skeleton-shimmer" />
            ))}
          </div>
        </div>
      </section>

      {/* Post grid */}
      <section className="py-16 bg-white skeleton-stagger-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-4 w-24 rounded bg-gray-200 mb-8 skeleton-shimmer" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="rounded-2xl overflow-hidden border border-gray-100">
                <div className="aspect-16/10 bg-linear-to-br from-gray-200 to-gray-100 skeleton-shimmer" />
                <div className="p-5 space-y-3">
                  <div className="flex gap-2">
                    <div className="h-5 w-16 rounded-full bg-[#243462]/10 skeleton-shimmer" />
                    <div className="h-5 w-20 rounded-full bg-gray-100 skeleton-shimmer" />
                  </div>
                  <div className="h-6 w-3/4 rounded-lg bg-gray-200 skeleton-shimmer" />
                  <div className="space-y-1.5">
                    <div className="h-3 w-full rounded bg-gray-100 skeleton-shimmer" />
                    <div className="h-3 w-5/6 rounded bg-gray-100 skeleton-shimmer" />
                  </div>
                  <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
                    <div className="w-8 h-8 rounded-full bg-gray-200 skeleton-shimmer" />
                    <div className="h-3 w-24 rounded bg-gray-100 skeleton-shimmer" />
                    <div className="h-3 w-16 rounded bg-gray-100 ml-auto skeleton-shimmer" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
